import {Col, Container, Row} from "react-bootstrap";
import React, {useContext, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {WiresPanelContext} from "../../pages/wires/context";

export default function RejectModal(props) {

    const {setShowReject, setShow} = props
    const {isDesktop, isMobile} = useWindowDimensions();
    const {handleReject} = useContext(WiresPanelContext);
    const [rejecting, setRejecting] = useState(false);
    let confirmDeleteBtnClassName = "btn btn-block ";
    confirmDeleteBtnClassName += isDesktop ? 'td-btn-primary-light' : 'td-btn-red ';
    return (<>
        <Container fluid className={"my-3 my-md-0"}>
            <Row>
                <Col md={12}>
                    <h4 style={{textAlign: isDesktop?'left':'center'}}>Are you sure you want to reject this?</h4><br/>
                </Col>
            </Row>
            <Row className={"justify-content-end"}>
                <Col md={4} xs={12} className='pr-0 d-none d-md-block'>
                    <button disabled={rejecting} className='btn btn-block td-btn-secondary-clear' href="#" onClick={() => {
                        setShow(false);
                        setShowReject(false);
                    }}>Cancel
                    </button>
                </Col>
                <Col md={4} xs={11} sm={12} className={isMobile?'stick-to-bottom':''}>
                    <button  disabled={rejecting} className={confirmDeleteBtnClassName} href="#" onClick={() => {

                        const onSuccess = () => {
                        }

                        const onError = (err) => {
                        }
                        setShow(false);
                        setShowReject(false);

                        setRejecting(true);
                        handleReject(onSuccess, onError);

                    }}>Reject
                    </button>
                </Col>
            </Row>
        </Container>
    </>)
}

